import SVGS from "../svgs/SVGS"

const InstallPLuginCheck = ({ border, text }) => {
  const { CheckMarkCCSVG, CheckMarkCESVG } = SVGS()
  return (
    <div className={"install-plugin"}>
      {window.cheqEssential && <CheckMarkCESVG />}
      {!window.cheqEssential && <CheckMarkCCSVG />}
      <span className="install-plugin-text">{text}</span>
    </div>
  )
}

export default InstallPLuginCheck
